import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { Amplify } from 'aws-amplify';
import { defaultStorage } from 'aws-amplify/utils';

import cognito from '../../../config/cognito';
import { APPSYNC_ENVIRONMENT } from '../../../config/environment';

export const configAuth = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cognito.userPoolId,
        userPoolClientId: cognito.clientId,
        loginWith: {
          oauth: {
            responseType: 'code',
            redirectSignIn: [cognito.callbackSignIn],
            redirectSignOut: [cognito.callbackSignOut],
            domain: cognito.userPoolDomain,
            scopes: [
              'email',
              'openid',
              'profile',
              'aws.cognito.signin.user.admin',
            ],
          },
        },
      },
    },
    API: {
      Events: {
        endpoint: APPSYNC_ENVIRONMENT.ENDPOINT,
        region: APPSYNC_ENVIRONMENT.REGION,
        defaultAuthMode: 'userPool',
      },
    },
  });

  cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
};
